module.exports = {
  //Funcion con refresco
  request: function(req, token) {
    //token = token.split(';')
    //this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});

    var refresh = false;
    var r_token = token.split(";");

    //Vamos a ver si esta llamando a la url de refresco
    if (req.method == "post" && req.url.indexOf("api/oauth/refresh") > -1) {
      //req.hasOwnProperty('data') &&
      refresh = true;
    }

    if (refresh) {
      req.data = {
        grant_type: "refresh_token",
        refresh_token: r_token[1],
        client_id: process.env.VUE_APP_CI,
        client_secret: process.env.VUE_APP_CS,
        scope: ""
      };
    } else {
      //this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + r_token[0]});
      this.http.setHeaders.call(this, req, {
        Authorization: "Bearer " + r_token[0]
      });
    }

    /*
        const refresh = req.data.indexOf('refreshToken') > -1
              token = token.split(';')

        //Llamada normal sin refresco de token
        if(!refresh){
            console.log('Login normal')
            //Ponemos la cabecera de autorizacion con el token normal
            token = token[0];
            this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});

        }else{ //Si etsamos refrescando montamos la llamada
            console.log('refresco')
            token = token[1]; //Cogemos el token de refresco
            req.data = {
                'grant_type': 'refresh_token',
                'refresh_token': token,
                'client_id': '5',
                'client_secret': 'nwRZSsKw54iIEbrXio6G9BkllC1P0RIQS4HzM86n',
                'scope': ''
            }

            console.log(req);

        }
        */
  },
  response: function(res) {
    if (res.data.access_token && res.data.refresh_token) {
      // && res.data.refresh_token) {
      var token_group = res.data.access_token + ";" + res.data.refresh_token;

      return token_group; // + ';' + res.data.expires_in;
    }
  }
};
